import formatDate from '../../../../components/common/formatDate';
import TableCompHead from '../../../../components/ui/TableCompHead';

interface IProps {
  moduleData: any;
}

const colSpanRevHeader = (head: string) => {
  if (head === 'Action Taken') return 5;
  if (head === 'Detail After Change') return 3;
  if (head === 'Detail Before Change' || head === 'Change Sugg.To') return 2;
  return 1;
};
const THead = ({ moduleData }: IProps) => {
  return (
    <thead>
      <TableCompHead
        colSpan={17}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading="PROCESS CONTROL STANDARD"
      />
      <tr>
        {moduleData.part_type === 'prototype' ? (
          <td
            colSpan={2}
            style={{
              border: '1px solid black',
            }}
            align="left"
          >
            <span
              style={{
                fontSize: '2.5rem',
                marginRight: '0.6rem',
              }}
            >
              ☑
            </span>
            <span>Proto Type</span>
          </td>
        ) : (
          <td colSpan={2} align="left" style={{ border: '1px solid black' }}>
            <span
              style={{
                fontSize: '2.5rem',
                marginRight: '0.6rem',
              }}
            >
              □
            </span>
            <span>Proto Type</span>
          </td>
        )}

        {moduleData.part_type === 'pre-Launch' ? (
          <td
            colSpan={2}
            style={{
              border: '1px solid black',
            }}
            align="left"
          >
            <span
              style={{
                fontSize: '2.5rem',
                marginRight: '0.6rem',
              }}
            >
              ☑
            </span>
            <span>Pre-Launch</span>
          </td>
        ) : (
          <td colSpan={2} align="left" style={{ border: '1px solid black' }}>
            <span
              style={{
                fontSize: '2.5rem',
                marginRight: '0.6rem',
              }}
            >
              □
            </span>
            <span>Pre-Launch</span>
          </td>
        )}

        {moduleData.part_type === 'production' ? (
          <td
            colSpan={2}
            align="left"
            style={{
              border: '1px solid black',
            }}
          >
            <span
              style={{
                fontSize: '2.5rem',
                marginRight: '0.6rem',
              }}
            >
              ☑
            </span>
            <span>Production</span>
          </td>
        ) : (
          <td colSpan={2} align="left" style={{ border: '1px solid black' }}>
            <span
              style={{
                fontSize: '2.5rem',
                marginRight: '0.6rem',
              }}
            >
              □
            </span>
            <span>Production</span>
          </td>
        )}
        <td colSpan={11}></td>
      </tr>
      <tr>
        <th colSpan={1} align="left" rowSpan={2}>
          PART NAME
        </th>
        <th colSpan={6} align="left" rowSpan={2}>
          {moduleData?.part_id?.part_name}
        </th>
        <th colSpan={2} align="left">
          CUSTOMER
        </th>
        <th colSpan={4} align="left">
          {moduleData?.part_id?.customer_id?.customer_name}
        </th>
        <th colSpan={2} align="left">
          DOC NO
        </th>
        <th colSpan={2} align="left">
          {moduleData.doc_no}
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          MODEL
        </th>
        <th colSpan={4} align="left">
          {moduleData?.model}
        </th>
        <th colSpan={2} align="left">
          KEY /ORIG. DATE
        </th>
        <th colSpan={2} align="left">
          {' '}
          {formatDate(moduleData?.part_id?.date_orig)}
        </th>
      </tr>
      <tr>
        <th colSpan={1} align="left" rowSpan={2}>
          PART NO
        </th>
        <th colSpan={6} align="left" rowSpan={2}>
          {moduleData?.part_id?.part_number}
        </th>
        <th colSpan={2} align="left">
          SUPPLIER NAME
        </th>
        <th colSpan={4} align="left">
          {moduleData?.part_id?.supplier_name}
        </th>
        <th colSpan={2} rowSpan={2} align="left">
          REV. NO. / DATE{' '}
        </th>
        <th colSpan={2} rowSpan={2} align="left">
          00 / 06.02.2023
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          SUPPLIER CODE
        </th>
        <th colSpan={4} align="left">
          {moduleData?.part_id?.customer_id?.supplier_code}
        </th>
      </tr>
      <tr>
        <th colSpan={1} align="left">
          CORE TEAM
        </th>
        <th colSpan={12} align="left">
          {moduleData?.part_id?.core_team}
        </th>
        <th align="left" colSpan={4}>
          PROCESS RESPONSIBILITY : {moduleData?.process_resp}
        </th>
      </tr>
    </thead>
  );
};

export default THead;
